import { Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

interface Props {
  text: string;
}

const ShowMoreText: React.FC<Props> = ({ text }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const computedStyle = getComputedStyle(el);
      const lineHeightStr = computedStyle.lineHeight;
      const lineHeight = isNaN(parseFloat(lineHeightStr)) ? 20 : parseFloat(lineHeightStr); // fallback 20px
      const maxHeight = lineHeight * 7;
      setIsOverflowing(el.scrollHeight > maxHeight);
    }
  }, [text]);

  return (
    <div className='space-y-2'>
      <Typography
        ref={textRef}
        fontSize={{ xs: '14px', md: '18px' }}
        variant='bodyLarge'
        color='#FFFFFF'
        className='mix-blend'
        sx={{
          overflow: expanded ? 'visible' : 'hidden',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: expanded ? 'none' : 7,
          textOverflow: 'ellipsis',
          whiteSpace: 'normal',
          maxHeight: expanded ? 'none' : 'unset',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}>
        {text}
      </Typography>

      {isOverflowing && (
        <Typography
          onClick={() => setExpanded(!expanded)}
          aria-expanded={expanded}
          className='mix-blend'
          sx={{
            fontSize: { xs: '12px' },
            color: '#FFFFFF',
            cursor: 'pointer',
            textDecoration: 'underline',
            width: 'fit-content',
            '&:hover': {
              opacity: 0.8,
            },
          }}>
          {expanded ? 'Show less' : 'Show more'}
        </Typography>
      )}
    </div>
  );
};

export default ShowMoreText;
